import script from "./CustomSelect2.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSelect2.vue?vue&type=script&setup=true&lang=js"

import "./CustomSelect2.vue?vue&type=style&index=0&id=dbfaeac6&lang=scss"

const __exports__ = script;

export default __exports__